/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction, SliceCaseReducers, ValidateSliceCaseReducers } from '@reduxjs/toolkit';
import { Common, Store } from '@sv-support-sdk/shared-types';

type IChatsState = Store.Chats.IChatsState;

export const initialState: IChatsState = {
  list: [],
  listMeta: { perPage: '30', total: 0, orderByDirection: 'desc', currentPage: 1 },
  loading: {
    list: false,
    selectedChat: false,
    attachments: false,
    createChat: false,
  },
  selectedChat: null,
} as IChatsState;

const createChatsSlice = <T extends IChatsState, Reducers extends SliceCaseReducers<T>>({
  name = 'chats',
  initialState,
  reducers,
}: {
  name: string;
  initialState: T;
  reducers: ValidateSliceCaseReducers<T, Reducers>;
}) => {
  return createSlice({
    name,
    initialState,
    reducers: {
      setChats(state, action: PayloadAction<Common.Chats.IChat[]>) {
        // eslint-disable-next-line no-param-reassign
        state.list = action.payload;
      },
      setChatsMeta(state, action: PayloadAction<Partial<Store.Chats.IChatsMeta>>) {
        state.listMeta = { ...state.listMeta, ...action.payload };
      },
      setSelectedChat(state, action: PayloadAction<Common.Chats.IChat>) {
        state.selectedChat = action.payload;
      },
      setLoading(state, action: PayloadAction<{ key: string; value: boolean }>) {
        //@ts-ignore
        state.loading[action.payload.key] = action.payload.value;
      },
      resetState: () => ({
        ...initialState,
      }),
      ...reducers,
    },
  })
}

export default createChatsSlice;
